import React from 'react';

const ArrowRightIcon24 = ({ className }) => (
  <svg className={className} height="24" width="24">
    <path d="m4 10.92v2h12l-5.5 5.5 1.42 1.42 7.92-7.92-7.92-7.92-1.42 1.42 5.5 5.5z" />
  </svg>
);

export default ArrowRightIcon24;
